import dayjs from 'dayjs';
import ru from 'dayjs/locale/ru';

export const dayjsInit = () => {
    dayjs.locale(ru, {
        weekdays: ['Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота', 'Воскресенье'],
        weekdaysShort: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'],
    });
};
